import { render } from "./DatabaseVariablesNew.vue?vue&type=template&id=0ea1d0ee"
import script from "./DatabaseVariablesNew.vue?vue&type=script&lang=js"
export * from "./DatabaseVariablesNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__